import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const SearchFiltersContext = createContext();

export const useFilter = () => useContext(SearchFiltersContext);

export const SearchFiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState({});
  const location = useLocation();

  // console.log("filters: ", filters);

  const getMainRoute = (path) => path.split("/")[1] || "";

  const setPageFilters = (pageKey, newFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [pageKey]: newFilters
    }));
  };

  const getPageFilters = (pageKey) => {
    return filters[pageKey] || {};
  };

  const clearPageFilters = (pageKey) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      delete newFilters[pageKey];
      return newFilters;
    });
  };

  useEffect(() => {
    const currentMainRoute = getMainRoute(location.pathname);

    if (filters[currentMainRoute] === undefined) {
      setFilters({
        [currentMainRoute]: filters[currentMainRoute] || {}
      });
    }
  }, [location.pathname, filters]);

  return (
    <SearchFiltersContext.Provider
      value={{ filters, setPageFilters, getPageFilters, clearPageFilters }}
    >
      {children}
    </SearchFiltersContext.Provider>
  );
};
